import {environment} from '../../environments/environment';

export class Config {
    get version(): string {
      return this._version;
    }
    get serverUrl(): string {
    return  this._serverUrl;
    }
    get platform(): string {
      return this._platform;
    }
    // tslint:disable-next-line:variable-name
    private _serverUrl = environment.serverUrl;
    private _platform = environment.platform;
    private _version = environment.version;
}
